/* ============================================================
   Forgeline — Custom-wheel fitment gate
   When the cart contains a custom wheel (product.type contains
   "Custom Wheels" and NOT "Flow Formed"), intercept the Checkout
   button (cart page + mini-cart drawer) and require Year/Make/
   Model (+ optional Trim / Stock-or-Modified / Notes) before
   sending the buyer to checkout. Captures the answers as cart
   attributes so they land on the order. Also hides the express
   wallet buttons for custom-wheel carts (belt-and-suspenders with
   the server-side hide in main-cart-footer).
   ============================================================ */
(function () {
  'use strict';

  // Covers every checkout trigger in this theme: the custom cart page link
  // (.cart-checkout-btn in gtu-cart), the Dawn cart button (#checkout), the
  // drawer button (#CartDrawer-Checkout) and the add-to-cart notification —
  // the last three all carry name="checkout".
  var CHECKOUT_SELECTOR = '.cart-checkout-btn, [name="checkout"]';
  var ATTR = {
    year: 'Vehicle Year',
    make: 'Vehicle Make',
    model: 'Vehicle Model',
    trim: 'Vehicle Trim',
    condition: 'Stock or Modified',
    notes: 'Fitment Notes',
  };

  var modal = document.getElementById('fgl-fitment');
  if (!modal) return;
  var form = modal.querySelector('#fgl-fitment-form');
  var errorEl = modal.querySelector('#fgl-fitment-error');

  var state = { custom: false, provided: false, ymmLoaded: false, lastTrigger: null };

  function isCustomWheel(item) {
    var t = (item.product_type || '').toLowerCase();
    return t.indexOf('custom wheels') > -1 && t.indexOf('flow formed') === -1;
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        state.custom = (cart.items || []).some(isCustomWheel);
        var a = cart.attributes || {};
        state.provided = !!(a[ATTR.make] && a[ATTR.model]);
        document.body.classList.toggle('fgl-has-custom-wheel', state.custom);
        prefill(a);
        return cart;
      })
      .catch(function () { return null; });
  }

  function prefill(a) {
    if (!a) return;
    set('[data-vehicle-field="year"]', a[ATTR.year]);
    set('[data-vehicle-field="make"]', a[ATTR.make]);
    set('[data-vehicle-field="model"]', a[ATTR.model]);
    set('[name="trim"]', a[ATTR.trim]);
    set('[name="notes"]', a[ATTR.notes]);
    if (a[ATTR.condition]) {
      var r = form.querySelector('input[name="condition"][value="' + a[ATTR.condition] + '"]');
      if (r) r.checked = true;
    }
  }
  function set(sel, value) {
    var el = form.querySelector(sel);
    if (el && value != null && value !== '') el.value = value;
  }

  // Lazy-load the CarAPI Year/Make/Model selector only when first needed.
  function loadYMM() {
    if (state.ymmLoaded) return;
    state.ymmLoaded = true;
    window.GTU_VEHICLE_DATA_URL = modal.getAttribute('data-ymm-data');
    var s = document.createElement('script');
    s.src = modal.getAttribute('data-ymm-src');
    s.defer = true;
    document.body.appendChild(s);
  }

  function openModal(trigger) {
    state.lastTrigger = trigger || null;
    loadYMM();
    if (errorEl) errorEl.hidden = true;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var first = form.querySelector('[data-vehicle-field="year"]');
    if (first) setTimeout(function () { first.focus(); }, 60);
  }
  function closeModal() {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (state.lastTrigger && state.lastTrigger.focus) state.lastTrigger.focus();
  }

  function val(sel) { var el = form.querySelector(sel); return el ? String(el.value || '').trim() : ''; }
  function collect() {
    return {
      year: val('[data-vehicle-field="year"]'),
      make: val('[data-vehicle-field="make"]'),
      model: val('[data-vehicle-field="model"]'),
      trim: val('[name="trim"]'),
      condition: (form.querySelector('input[name="condition"]:checked') || {}).value || '',
      notes: val('[name="notes"]'),
    };
  }

  function proceed() { window.location.href = '/checkout'; }

  // Capture-phase delegation: catches the Checkout button on the cart page AND
  // the drawer, including re-rendered copies, without per-element binding.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest(CHECKOUT_SELECTOR);
      if (!btn) return;
      // Always stop the default submit first, then decide on fresh cart state.
      e.preventDefault();
      e.stopPropagation();
      refreshCart().then(function () {
        if (state.custom && !state.provided) openModal(btn);
        else proceed();
      });
    },
    true
  );

  function getCookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? m.pop() : '';
  }

  // Cart pop-up → HubSpot Forms API (same public endpoint the contact form uses).
  // No-op until data-hs-form-id is set on the modal. Field → HubSpot contact
  // property mapping per the client's field sheet (2026-07-01):
  //   Year→car_year, Make→car_make, Model→car_model, Trim→car_trim,
  //   Stock/Modified→vehicle_condition, Notes→message.
  function submitToHubSpot(d) {
    var portalId = modal.getAttribute('data-hs-portal-id');
    var formId = modal.getAttribute('data-hs-form-id');
    if (!portalId || !formId) return; // not configured yet — safe no-op
    var fields = [];
    function add(name, value) {
      if (value) fields.push({ objectTypeId: '0-1', name: name, value: value });
    }
    add('car_year', d.year);
    add('car_make', d.make);
    add('car_model', d.model);
    add('car_trim', d.trim);
    add('vehicle_condition', d.condition);
    add('message', d.notes);
    var context = { pageUri: window.location.href, pageName: document.title };
    var hutk = getCookie('hubspotutk');
    if (hutk) context.hutk = hutk;
    try {
      fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + portalId + '/' + formId, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fields: fields, context: context }),
        keepalive: true, // completes even after we redirect to checkout
      }).catch(function () {});
    } catch (e) {}
  }

  function onSubmit(e) {
    e.preventDefault();
    var d = collect();
    if (!d.year || !d.make || !d.model) {
      if (errorEl) errorEl.hidden = false;
      return;
    }
    if (errorEl) errorEl.hidden = true;
    var btn = form.querySelector('.fgl-fitment__submit');
    if (btn) btn.setAttribute('aria-busy', 'true');

    // Fire the HubSpot submission (no-op until the form GUID is configured on the
    // modal). Fire-and-forget with keepalive so it survives the checkout redirect.
    submitToHubSpot(d);

    var attrs = {};
    attrs[ATTR.year] = d.year; attrs[ATTR.make] = d.make; attrs[ATTR.model] = d.model;
    attrs[ATTR.trim] = d.trim; attrs[ATTR.condition] = d.condition; attrs[ATTR.notes] = d.notes;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    })
      .then(function () { state.provided = true; proceed(); })
      .catch(function () { proceed(); }); // never block the sale on a save hiccup
  }

  modal.addEventListener('click', function (e) {
    if (e.target.hasAttribute('data-fgl-close')) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });
  if (form) form.addEventListener('submit', onSubmit);

  function init() { refreshCart(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
